import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/lib/auth';
import { AuthZoneGuard } from './auth-zone-guard';
import { FullPageLoader } from '@/shared/components/full-page-loader';

/** Guard de autenticação. Mostra loader enquanto resolve a sessão. */
export function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullPageLoader />;
  if (!isAuthenticated) {
    const redirectUrl = `${location.pathname}${location.search}`;
    const loginTo = `/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
    return <Navigate to={loginTo} replace />;
  }
  return (
    <>
      <AuthZoneGuard />
      <Outlet />
    </>
  );
}
